/* eslint-disable react/react-in-jsx-scope -- Unaware of jsxImportSource */

/** @jsxImportSource @emotion/react */
import React, { ReactElement } from "react";

import { css } from "@emotion/react";

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import ErrorPage from "Components/ErrorPage";

export default function InvalidToken(): ReactElement {
  async function handleSignIn() {
    window.location.href = "/login";
  }

  return (
    <ErrorPage title="Invalid Token">
      <Typography variant="body1">
        You are attempting to use an unauthorized token to access the system. Sign in again to authenticate.
      </Typography>
      <Button
        css={css`
          display: block;
          margin: 32px auto 0;
        `}
        color="primary"
        variant="contained"
        size="large"
        onClick={handleSignIn}
      >
        Sign In
      </Button>
    </ErrorPage>
  );
}
